import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { identify } from '@fff-web/fff-analytics';

const AnalyticsWrapper = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    identify();
  }, [location]);
  return children;
};

export default AnalyticsWrapper;
